import React from "react";
import styles from "../../static/css/pages.module.css";
import Title from "../../components/title/title";
import Moment from "react-moment";
import Icon from "../../components/icons/icons";
import axios from "axios";
import ieSvg from "../../components/icons/ieSvg";
import moment from "moment";

class NotificationsList extends React.Component {

  componentDidMount() {
    ieSvg();
    let now = new Date();
    let mnth = ("0" + (now.getUTCMonth() + 1)).slice(-2);
    let day = ("0" + now.getUTCDate()).slice(-2);
    let today = day + "." + mnth + "." + now.getFullYear()
    const date = document.querySelectorAll("time");
    date.forEach(function(e){
      const dataValue = e.innerHTML;
      const dataParent = e.closest("[data-history]").previousSibling;
      if (dataParent) {
        const dataParentVal = dataParent.querySelector("time").innerHTML;
        if (dataValue === dataParentVal) {
          e.parentElement.className += "  hidden";
        }
      }
      setTimeout(function(){
        if (dataValue === today) {
          e.innerHTML = 'Сегодня';
        }
      }, 100)
    });

    this.handleLoad()
  }

  handleLoad = () => {
    let ids = [];
    this.props.items.notifications.forEach(function(e) {
      if(e.status === "NEW") {
        ids.push(e.id)
      }
    });
    if (ids.length) {
      axios.all([
        axios.post(process.env.REACT_APP_GATE + "notifications/mark/read", {messageIds: ids}),
        axios.post(process.env.REACT_APP_GATE + "notifications/mark/delivered", {messageIds: ids})
      ]).then(responseArr => {
        if(responseArr[0]) {
          if(responseArr[0].data.result.status === "SUCCESS") {
            let notificationCount = document.getElementById("notifications-list");
            if(notificationCount) {
              notificationCount.style.display = 'none'
            }
            console.log('notifications/mark/read')
          }
        }
      })
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <div className="l-grid_pt-8 mobile_l-grid">
          <div className="l-grid__item_1"> </div>
          <div className="l-grid__item_6 mobile_l-grid__item_10">
            <Title icon="icon_menu-messages" title="Сообщения от ФНС"/>
            <div>
              {this.props.items.notifications.sort((b, a) => Date.parse(a.date) - Date.parse(b.date)).map((item, i) =>
                <div key={i} data-history>
                  <div className={styles.notification__group} data-date>
                    <Moment format="DD.MM.YYYY" local>{moment.utc(item.date)}</Moment>
                  </div>
                  <div className={styles.notification}>
                    {
                      item.status === "NEW" ?
                        <span className={styles.notification__icon}><Icon name="icon_message" viewbox="0 0 32 32" /></span>
                        :
                        <div className={styles.notification__icon}><Icon name="icon_message" viewbox="0 0 32 32" /></div>
                    }
                    <div className={styles.text_gray}>
                      <Moment element="i" format="HH:mm" local>{moment.utc(item.date)}</Moment>
                    </div>
                    <div className={styles.notification__title}>
                      {item.name}
                    </div>
                    <div className={styles.notification__body}>
                      {item.text}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.article}> </div>
      </div>
    )
  }
}

export default NotificationsList;
